<template>
  <div class="commingsoon-page">
    <div style="display:none">
      <img src="../../assets/img/default_thumbnail.jpg" style="width: 150px; height: 150px;" title="default_thumbnail" width="150" height="150" border="0" vspace="0" alt="default_thumbnail">
    </div>
    <HeaderCommon></HeaderCommon>
    <div class="pc-commingsoon-wrapper" :class="{'en':lang!='zh'}">
    </div>
    <div class="wap-commingsoon-wrapper" :class="{'en':lang!='zh'}">
    </div>
    <ScrollToTop></ScrollToTop>
    <FooterCommon></FooterCommon>
  </div>
</template>

<script>
import global from './common/common'
import HeaderCommon from './template/HeaderCommon'
import FooterCommon from './template/FooterCommon'
import ScrollToTop from './template/ScrollToTop'


export default {
  data () {
    return {
      lang: '',
    }
  },
  methods: {
    setLang () {
      this.lang = this.$cookies.get('language')|| global.initLang
    },
  },
  components: {
    HeaderCommon,
    FooterCommon,
    ScrollToTop
  },
  mounted () {
    this.setLang();
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/pc";
@import "~@/assets/scss/wap";
</style>



// WEBPACK FOOTER //
// src/components/pc/CommingSoon.vue